(function () {
    function pad(value) {
        return value < 10 ? '0' + value : String(value);
    }

    function format(ms) {
        var seconds = Math.ceil(ms / 1000);
        var d = Math.floor(seconds / 86400);
        var h = Math.floor((seconds % 86400) / 3600);
        var m = Math.floor((seconds % 3600) / 60);
        var s = seconds % 60;
        var parts = [];
        if (d) parts.push(d + 'd');
        if (d || h) parts.push(h + 'h');
        parts.push((d || h ? pad(m) : m) + 'm');
        parts.push(pad(s) + 's');
        return parts.join(' ');
    }

    function start(banner) {
        var end = Number(banner.dataset.pvCountdown) * 1000;
        var on = banner.querySelector('[data-pv-countdown-on]');
        var off = banner.querySelector('[data-pv-countdown-off]');
        var time = banner.querySelector('[data-pv-countdown-time]');
        if (!on || !off || !time || !end) return;

        function tick() {
            var left = end - Date.now();
            var active = left > 0;
            on.hidden = !active;
            off.hidden = active;
            if (!active) return clearInterval(timer);
            time.textContent = format(left);
        }

        var timer = setInterval(tick, 1000);
        tick();
    }

    function init() {
        document.querySelectorAll('[data-pv-countdown]').forEach(start);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
